import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TheRave} from "../TheRave";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {ReelState} from "../../core/reel/ReelState";
import {TimelineLite, TimelineMax} from "gsap";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";

export class TheRaveNormalIdlePresentation implements FlowStatePresentation {

    private _idleAnimationTimeline: TimelineMax | undefined;
    private _timestamp: number;

    constructor() {
    }

    public start(flowStateController: FlowStateController) {
        const enableBoostTl: TimelineLite = new TimelineLite();
        flowStateController.setSkipCallback(() => this.skip(flowStateController));

        this._timestamp = Date.now();

        TheRave.reels.forEach((reel) => {
            //console.log("REEL STATE STOPPED FOR REEL - IDLE, rID: " + reel.reelId);
            reel.reelState = ReelState.IDLE;
        });
        // TODO: Adding idle states for enhancer reels
        TheRave.enhancerReels.forEach((reel) => {
            //console.log("REEL STATE STOPPED FOR REEL, ENHANCER - IDLE, rID: " + reel.reelId);
            reel.reelState = ReelState.IDLE;
        });

        if (this._idleAnimationTimeline) {
            this._idleAnimationTimeline.pause();
            this._idleAnimationTimeline.kill();
        }

        this._idleAnimationTimeline = new TimelineMax({
            repeat: -1
        }).add(() => this.startOrResumeIdleAnimations(flowStateController.state), "+=0.2");

        if (TheRave.model.gameData?.nextMode != GameMode.NORMAL) {
            flowStateController.finish();
            return;
        }

        enableBoostTl.add(() => {
            if (TheRave.reels && TheRave.reels.length > 0 && TheRave.reels[1]) {
                TheRave.reels[1].showBoostButton();
            }
            if (!SlotKeypad.autoplay.isAutoplayRound) {
                TheRave.reels[1].enableBoostButton(true);
            }
        }, 0.3);

        if (!TheRave.isActionSpinsActive) {
            TheRave.individualWin.start();
        }

    }

    private startOrResumeIdleAnimations(flowstate: FlowState): void {

        if (flowstate !== FlowState.IDLE) {
            // stop and reset
            if (this._idleAnimationTimeline) {
                this._idleAnimationTimeline.pause();
                this._idleAnimationTimeline.kill();
            }
        } else {
            // ts check
            if (Date.now() >= this._timestamp + 8000 && flowstate === FlowState.IDLE) {
                this._timestamp = Date.now();
                TheRave.reels[1].reelView.addAndPlayIdleAnimation();
            }
        }

    }

    private async skip(flowStateController: FlowStateController): Promise<any> {
        if (this._idleAnimationTimeline) {
            this._idleAnimationTimeline.pause();
            this._idleAnimationTimeline.kill();
        }
        await TheRave.individualWin.stop();
        flowStateController.finish();
    }
}